/**
 * Navigation Module
 * Mobile menu and navigation functionality
 */

const Navigation = {
    mobileMenuToggle: null,
    mobileMenu: null,
    isOpen: false,

    init() {
        this.mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
        this.mobileMenu = document.querySelector('.mobile-nav');
        
        if (this.mobileMenuToggle && this.mobileMenu) {
            this.bindEvents();
        }
        
        setTimeout(() => {
            this.initMegaMenu();
        }, 100);
    },

    bindEvents() {
        this.mobileMenuToggle?.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }
        });

        document.addEventListener('click', (e) => {
            if (this.isOpen && this.mobileMenu && !this.mobileMenu.contains(e.target) && !this.mobileMenuToggle.contains(e.target)) {
                this.close();
            }
        });

        if (this.mobileMenu) {
            const dropdownToggles = this.mobileMenu.querySelectorAll('.has-dropdown > a');
            dropdownToggles.forEach(toggle => {
                toggle.addEventListener('click', (e) => {
                    if (window.innerWidth < 1024) {
                        e.preventDefault();
                        const parent = toggle.parentElement;
                        parent.classList.toggle('is-open');
                    }
                });
            });
        }
    },

    initMegaMenu() {
        const categoriesMenu = document.getElementById('mega-menu-categories');
        const brandsMenu = document.getElementById('mega-menu-brands');
        
        this.closeTimeout = null;
        
        const navMenus = document.querySelectorAll('.elementor-nav-menu');
        
        navMenus.forEach(navMenu => {
            const menuItems = navMenu.querySelectorAll('li.menu-item, li.elementor-item');
            
            menuItems.forEach(item => {
                const link = item.querySelector('a');
                if (!link) return;
                
                const title = link.textContent.toLowerCase().trim();
                const url = (link.getAttribute('href') || '').toLowerCase();
                
                const isProductsMenu = title.includes('produkte') || title.includes('shop') || url.includes('webshop') || url.includes('/shop');
                const isBrandsMenu = title.includes('marken') || title.includes('brands');
                
                if (isProductsMenu || isBrandsMenu) {
                    const type = isProductsMenu ? 'categories' : 'brands';
                    const megaMenuEl = isProductsMenu ? categoriesMenu : brandsMenu;
                    
                    item.classList.add('mega-menu');
                    
                    if (!megaMenuEl) return;
                    
                    item.addEventListener('mouseenter', () => {
                        if (window.innerWidth >= 1024) {
                            this.openMegaMenu(item, megaMenuEl, type);
                        }
                    });
                    
                    item.addEventListener('mouseleave', (e) => {
                        if (window.innerWidth >= 1024) {
                            this.closeTimeout = setTimeout(() => {
                                this.closeMegaMenu(megaMenuEl);
                            }, 200);
                        }
                    });
                    
                    megaMenuEl.addEventListener('mouseenter', () => {
                        if (this.closeTimeout) {
                            clearTimeout(this.closeTimeout);
                            this.closeTimeout = null;
                        }
                        item.classList.add('mega-menu--open');
                    });
                    
                    megaMenuEl.addEventListener('mouseleave', () => {
                        if (window.innerWidth >= 1024) {
                            this.closeTimeout = setTimeout(() => {
                                this.closeMegaMenu(megaMenuEl);
                            }, 200);
                        }
                    });
                }
            });
        });
        
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.elementor-nav-menu li.mega-menu') && !e.target.closest('#mega-menu-categories') && !e.target.closest('#mega-menu-brands')) {
                this.closeAllMegaMenus();
            }
        });
    },

    openMegaMenu(menuItem, megaMenuEl, type) {
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
            this.closeTimeout = null;
        }
        
        // Close all other mega menus first
        this.closeAllMegaMenus();
        
        menuItem.classList.add('mega-menu--open');
        
        const rect = menuItem.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const dropdownWidth = Math.min(1400, viewportWidth - 40);
        
        megaMenuEl.style.top = (rect.bottom + window.scrollY) + 'px';
        megaMenuEl.style.maxWidth = dropdownWidth + 'px';
        megaMenuEl.classList.add('mega-menu-dropdown--open');
        
        const grid = megaMenuEl.querySelector('.mega-menu-dropdown__grid');
        if (grid && grid.children.length === 0) {
            this.loadMegaMenuContent(grid, type);
        }
    },

    closeMegaMenu(megaMenuEl) {
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
            this.closeTimeout = null;
        }
        
        if (megaMenuEl) {
            megaMenuEl.classList.remove('mega-menu-dropdown--open');
        }
        document.querySelectorAll('.elementor-nav-menu li.mega-menu').forEach(item => {
            item.classList.remove('mega-menu--open');
        });
    },

    closeAllMegaMenus() {
        document.querySelectorAll('#mega-menu-categories, #mega-menu-brands').forEach(el => {
            el.classList.remove('mega-menu-dropdown--open');
        });
        document.querySelectorAll('.elementor-nav-menu li.mega-menu').forEach(item => {
            item.classList.remove('mega-menu--open');
        });
    },

    async loadMegaMenuContent(grid, type) {
        if (!grid || grid.children.length > 0) return;
        
        grid.innerHTML = '<div class="mega-menu__loading">Laden...</div>';
        
        try {
            const response = await fetch(`${cm_ajax?.ajax_url || '/wp-admin/admin-ajax.php'}?action=get_mega_menu_${type}&nonce=${cm_ajax?.nonce || ''}`);
            const data = await response.json();
            
            if (data.success && data.data.html) {
                grid.innerHTML = data.data.html;
                
                const items = grid.querySelectorAll('.mega-menu__item');
                items.forEach((el, index) => {
                    el.style.animationDelay = `${index * 0.05}s`;
                });
            } else {
                grid.innerHTML = '<div class="mega-menu__error">Inhalte konnten nicht geladen werden</div>';
            }
        } catch (error) {
            grid.innerHTML = '<div class="mega-menu__error">Fehler beim Laden</div>';
        }
    },

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    },

    open() {
        this.isOpen = true;
        this.mobileMenu?.classList.add('is-open');
        this.mobileMenuToggle?.classList.add('is-active');
        document.body.classList.add('menu-open');
        this.mobileMenuToggle?.setAttribute('aria-expanded', 'true');
    },

    close() {
        this.isOpen = false;
        this.mobileMenu?.classList.remove('is-open');
        this.mobileMenuToggle?.classList.remove('is-active');
        document.body.classList.remove('menu-open');
        this.mobileMenuToggle?.setAttribute('aria-expanded', 'false');
    }
};

document.addEventListener('DOMContentLoaded', () => {
    Navigation.init();
});

export default Navigation;